import { ApiError } from '../api/client';
import type { MessageKey } from '../i18n/mk';

/**
 * The message for a failed call. The API's own `detail` text is never shown (it is English and
 * technical); the code picks a translated message instead.
 */
export function errorMessageKey(e: unknown): MessageKey {
  if (!(e instanceof ApiError)) return 'error.generic';
  if (e.isNetwork) return 'error.network';
  switch (e.code) {
    case 'SESSION_EXPIRED':
      return 'error.session';
    case 'DATE_INVALID':
      return 'error.dateInvalid';
    case 'DATE_RANGE_TOO_LONG':
      return 'error.rangeTooLongGeneric';
    case 'PANEL_REQUIRED':
      return 'upsell.title';
    default:
      return e.status === 429 ? 'error.tooMany' : 'error.generic';
  }
}
